export const POSTAL = "postal"
export const DROPOFF = "dropoff"
export const PICKUP = "pickup"
export const UNKNOWN = "unknown_mode"
export const RETURNS = "returns"
export const SHIPPING = "shipping"
export const CHECKOUT = "checkout"
export const RETURN_BREADCRUMBS = [RETURNS, SHIPPING, CHECKOUT]
export const INSTRUCTIONS = "instructions"
export const TRACKING = "tracking"
export const CONFIRMATION_BREADCRUMBS = [INSTRUCTIONS, TRACKING]
export const COMPUTED = "computed"



// WEBPACK FOOTER //
// ./app/javascript/components/assets/constant.js